// src/pages/auth/LoginPage.jsx
import React from 'react';
import AuthLayout from "@layouts/AuthLayout";
import { LoginForm } from '@/components/forms/LoginForm';

const HomePage = () => {
  return(
    <h1> Welcome to Zelospace!</h1>
  )
};

export default HomePage;